// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__tZL1u","header__brand":"styles_header__brand__FeB0L","header__nav":"styles_header__nav__o5CqR"};